
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 26 28","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"26","height":"28","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAQAAADVGmdYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGhNWMEN5AAAAvElEQVQ4y8WUMQ6CQBBF3y5WVlReAwpPQekhFPAYNByG2sRSem5A5QWIjYUF34aY7RwwkSne/uZn8zabQZEqPfRQrb1qQ6oUoas6pUrU6K5GyZeUqtMVSVshL2/kTvLAEziRG/kCJ+GYMzGDn1WYxn9Ob2RQOnIykjWcHM7IoFRQGrmK0/9KJWcjg4dwgEyMGTbTTTLzV6ecwsjAyQOjiYHTaOavTrM+7KIVtmhZejIu3GjpOdDTfkk3LmRvibASWjVdEU0AAAAASUVORK5CYII="}})])
          )
        }
      }
    